module.exports = __webpack_public_path__ + "static/media/blog4_4.a668ae03.webp";